export default __webpack_public_path__ + "static/media/Wildstrider Jerkin.0c0e4cea.jpg";